const EMAIL_REGEXP = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_#^()=+<>?&])[A-Za-z\d@$!%*-_#^()=+<>?&]{8,}$/;
const PHONE_REGEXP = /^[0-9]{10}$/;

export {
  EMAIL_REGEXP,
  PASSWORD_REGEX,
  PHONE_REGEXP,
};
